import { useRef, useCallback } from 'react';

/**
 * Returns a throttled version of the callback that can only be called
 * once per `delayMs` milliseconds.
 */
export function useThrottle<T extends (...args: any[]) => void>(
  callback: T,
  delayMs: number
): T {
  const lastCallRef = useRef(0);

  return useCallback((...args: any[]) => {
    const now = Date.now();
    if (now - lastCallRef.current >= delayMs) {
      lastCallRef.current = now;
      callback(...args);
    }
  }, [callback, delayMs]) as unknown as T;
}
